<style scoped>

  @media only screen and (min-width: 991px) {
    .inline.fields {
      margin-top: -15px !important;
    }
  }

</style>


<template>

  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="goBack()">
        <i class="reply icon m-r-5"></i> Usuários
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">

      <div class="ui segment">
        <h4 class="ui dividing header">Acessos</h4>        
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Status  <span class="red text">*</span></label> 
            </div> 
          </div>
          <div class="inline fields">
            <div class="field">
              <div class="ui radio checkbox user-form-checkbox" :class="{ disabled: disableAccessSegment }">
                <input type="radio" class="hidden" :value="true" v-model="user.active">
                <label><i class="check circle green icon"></i>Ativo</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox user-form-checkbox m-l-10" :class="{ disabled: disableAccessSegment }">
                <input type="radio" class="hidden" :value="false" v-model="user.active">
                <label><i class="ban red icon"></i>Bloqueado</label>
              </div>
            </div>
          </div>
          <div class="fields m-t-20">
            <div class="sixteen wide field">
              <label class="form-label">Perfil  <span class="red text">*</span></label> 
            </div> 
          </div>
          <div class="inline fields">            
            <div class="field">
              <div class="ui radio checkbox user-form-checkbox" :class="{ disabled: disableAccessSegment }">
                <input type="radio" class="hidden" value="employee" v-model="user.group">
                <label><user-group-icon group="employee" /> Colaboradores</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox user-form-checkbox m-l-10" :class="{ disabled: disableAccessSegment }">
                <input type="radio" class="hidden" value="customer" v-model="user.group">
                <label><user-group-icon group="customer" /> Clínicas</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox user-form-checkbox m-l-10" :class="{ disabled: disableAccessSegment }">
                <input type="radio" class="hidden" value="vet" v-model="user.group">
                <label><user-group-icon group="vet" /> Veterinários</label>
              </div>
            </div>  
            <div class="field">
              <div class="ui radio checkbox user-form-checkbox m-l-10" :class="{ disabled: disableAccessSegment }">
                <input type="radio" class="hidden" value="financial" v-model="user.group">
                <label><user-group-icon group="financial" /> Financeiro</label>
              </div>
            </div>            
            <div class="field">
              <div class="ui radio checkbox user-form-checkbox m-l-10" :class="{ disabled: disableAccessSegment }">
                <input type="radio" class="hidden" value="admin" v-model="user.group">
                <label><user-group-icon group="admin" /> Administradores</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui segment">
        <h4 class="ui dividing header">Identificação</h4>        
        <div class="ui form">
          <div class="fields">
            <div class="six wide field">
              <label class="form-label">Nome <span class="red text">*</span></label>
              <input class="uppercase" v-model="user.name" @blur="user.name = $toUpperCase($event)">
            </div>
            <div class="six wide field">
              <label class="form-label">Sobrenome <span class="red text">*</span></label>
              <input class="uppercase" v-model="user.lastName" @blur="user.lastName = $toUpperCase($event)">
            </div>
            <div class="four wide field">
              <label class="form-label">E-mail <span class="red text">*</span></label>
              <input type="email" v-model="user.email" :readonly="isUpdating" @blur="user.email = $clearEmail($event)">
            </div>
          </div>
          <div class="fields">
            <div v-if="isCreating" class="three wide field">
              <label class="form-label">Senha <span class="red text">*</span></label>
              <input type="password" v-model="password">
            </div>
            <div v-if="isCreating" class="three wide field">
              <label class="form-label">Confirme a senha <span class="red text">*</span></label>
              <input type="password" v-model="confPassword">
            </div>  
            <div v-if="isUpdating" class="three wide field">
              <label class="form-label">Criado em</label>
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input :value="$formatDate(user.createdAt)" readonly="readonly">
              </div>
            </div>
            <div v-if="isUpdating && user.blockedAt" class="three wide field">
              <label class="form-label">Bloqueado em</label>
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input :value="$formatDate(user.blockedAt)" readonly="readonly">
              </div>
            </div>                      
          </div>          
        </div>
      </div>

      <div class="ui segment form-segment">
        <h4 class="ui dividing header">Dados Pessoais</h4>
        <div class="ui form">
          <div class="fields">    
            <div class="four wide field animated fadeIn">
              <label class="form-label">{{ person == 'F' ? 'CPF' : 'CNPJ' }}</label>
              <the-mask type="tel" :mask="['##.###.###/####-##', '###.###.###-##']" v-model="user.cgc" />
            </div>
            <div class="three wide field">
              <label class="form-label">Celular</label>
              <input v-model="user.mobile">
            </div>
            <div class="three wide field">
              <label class="form-label">Telefone</label>
              <input v-model="user.phone">
            </div>
            <div class="three wide field">
              <label class="form-label">Dia do Aniversário</label>
              <select-day ref="selectBirthDay" @onChange="onChangeBirthDay" />
            </div>
            <div class="three wide field">
              <label class="form-label">Mês do Aniversário</label>
              <select-month ref="selectBirthMonth" :uppercase="false" @onChange="onChangeBirthMonth" />
            </div>
          </div>
          <div class="fields">
            <div class="four wide field animated fadeIn">
              <label class="form-label">CEP</label>
              <the-mask type="tel" :mask="'#####-###'" v-model="user.zipCode" @blur.native="loadAddressByZipCode()" />
            </div>
            <div class="seven wide field">
              <label class="form-label">Logradouro</label>
              <input class="uppercase" placeholder="Rua, Avenida, Praça, etc." v-model="user.address" @blur="user.address = $toUpperCase($event)">
            </div>
            <div class="two wide field">
              <label class="form-label">Número</label>
              <input class="uppercase" v-model="user.number" @blur="user.number = $toUpperCase($event)">
            </div>
            <div class="three wide field">
              <label class="form-label">Complemento</label>
              <input class="uppercase" v-model="user.complement" @blur="user.complement = $toUpperCase($event)">
            </div>            
          </div>
          <div class="fields">            
            <div class="four wide field">
              <label class="form-label">Bairro</label>
              <input class="uppercase" v-model="user.district" @blur="user.district = $toUpperCase($event)">
            </div>
            <div class="seven wide field">
              <label class="form-label">Município</label>
              <input class="uppercase" v-model="user.city" @blur="user.city = $toUpperCase($event)">
            </div>
            <div class="five wide field">
              <label class="form-label">Estado</label>
              <select-state ref="selectState" @onChange="onChangeState" />
            </div>                        
          </div>
        </div>
      </div>  

      <div class="ui segment">
        <h4 class="ui dividing header">Conta Bancária</h4>        
        <div class="ui form">
          <div class="fields">
            <div class="three wide field">
              <label class="form-label">CNPJ / CPF</label>
              <the-mask type="tel" :mask="['##.###.###/####-##', '###.###.###-##']" v-model="user.bankCgc" />
            </div>
            <div class="five wide field">
              <label class="form-label">Banco</label>
              <select-bank ref="selectBank" @onChange="onChangeBank" />
            </div>
            <div class="two wide field">
              <label class="form-label">Agência</label>
              <input v-model="user.bankAgency">
            </div>
            <div class="four wide field">
              <label class="form-label">Conta</label>
              <input v-model="user.bankAccount">
            </div>   
            <div class="two wide field">
              <label class="form-label">DV Conta</label>
              <input v-model="user.bankAccountDigit" maxlength="1">
            </div>   
          </div>
        </div>
      </div> 

      <div class="ui segment">
        <h4 class="ui dividing header">Financeiro</h4>    
        <div class="ui form">
          <div class="fields">            
            <div class="three wide field">              
              <label class="form-label">
                <i :class="serviceTypeIcons.normal.icon"></i>
                % Adic. Normal
              </label>
              <input class="money" :value="normalAdd" @blur="normalAdd = $event.target.value">
            </div>   
            <div class="three wide field">
              <label class="form-label">
                <i :class="serviceTypeIcons.return.icon"></i>
                % Adic. Controle
              </label>
              <input class="money" :value="returnAdd" @blur="returnAdd = $event.target.value">
            </div>
            <div class="three wide field">
              <label class="form-label">
                <i :class="serviceTypeIcons.duty.icon"></i>
                % Adic. Plantão
              </label>
              <input class="money" :value="dutyAdd" @blur="dutyAdd = $event.target.value">
            </div>
            <div class="three wide field">
              <label class="form-label">
                <i :class="serviceTypeIcons.others.icon"></i>
                % Adic. Outros
              </label>
              <input class="money" :value="othersAdd" @blur="othersAdd = $event.target.value">
            </div>
          </div>
        </div>
      </div>

      <div class="ui segment form-segment">        
        <h4 class="ui dividing header">Assinatura</h4>
        <p v-show="isCreating" class="grey text m-t-20">
          <i class="info circle icon"></i> Confirme a criação do usuário antes de definir uma assinatura
        </p>
        <div v-show="isUpdating" class="ui grid">
          <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
            <file-upload
              ref="signatureUploader"
              fileType="image"
              :singleFile="true"
              :uploadPath="`/users/${this.user.id}/signature`"
              :loader="loadSignature"
              sendButtonLabel="Enviar assinatura"
              dragTipLabel="Você também pode arrastar a assinatura aqui"
              sendingLabel="Enviando assinatura..."
              noUploadedFilesLabel="Nenhuma assinatura enviada"
              @onRemove="onRemoveSignature"
            />
          </div>
          <div v-show="signature.file" class="ten wide computer sixteen wide tablet sixteen wide mobile column animated fadeIn">
            <p class="grey text">
              <i class="info circle icon"></i> Configurações da assinatura no PDF dos Laudos
            </p>
            <div class="ui form">              
              <div class="fields">
                <div class="three wide field">
                  <label class="form-label">Coluna <span class="red text">*</span></label>
                  <input class="integer" :value="signatureColumn" @blur="signatureColumn = $event.target.value">
                </div>                              
                <div class="three wide field">
                  <label class="form-label">Altura <span class="red text">*</span></label>
                  <input class="integer" :value="signatureHeight" @blur="signatureHeight = $event.target.value">
                </div>                              
                <div class="three wide field">
                  <label class="form-label">Largura <span class="red text">*</span></label>
                  <input class="integer" :value="signatureWidth" @blur="signatureWidth = $event.target.value">
                </div>
                <div class="three wide field">
                  <label class="form-label">Margem Superior</label>
                  <input class="integer" :value="signatureMarginTop" @blur="signatureMarginTop = $event.target.value">
                </div>
                <div class="three wide field">
                  <label class="form-label">Margem Inferior</label>
                  <input class="integer" :value="signatureMarginBottom" @blur="signatureMarginBottom = $event.target.value">
                </div>
              </div>
              <div class="fields">
                <div class="nine wide field">
                  <label class="form-label">Nome <span class="red text">*</span></label>
                  <input v-model="signature.name">
                </div>                                      
              </div> 
              <div class="fields">
                <div class="six wide field">
                  <label class="form-label">CRMV <span class="red text">*</span></label>
                  <input v-model="signature.crmv">
                </div>          
              </div>
            </div>
          </div>
        </div>
      </div>      

      <div class="m-t-20 m-b-20">
        <button class="ui basic button" @click="goBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating && !isRootUser" class="ui basic red button m-l-10" 
          :class="{ loading: checkingRemoval || removing }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving, disabled: !canConfirm }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

    </div>

    <can-not-remove-modal ref="canNotRemoveModal" />

    <yes-no-modal ref="confirmRemovalModal" danger="true"
      :message="`Confirma exclusão do usuário ${user.name} ?`"  @onYes="onConfirmRemoval()" />

  </div>
  
</template>

<script>

  import UserService from "@/services/user-service"
  import ZipCodeService from "@/services/zip-code-service"
  import SrvService from "@/services/srv-service"
  import Input from "@/utils/input"
  import { TheMask } from "vue-the-mask"
  import { formPage, onlyAdmin } from "@/mixins"    
  import { FileUpload, SelectDay, SelectMonth, SelectBank, SelectState, UserGroupIcon } from "@/components"

  export default {
    
    name: "UserForm",

    mixins: [formPage, onlyAdmin],

    data() {
      return {        
        indexRoute: "/admin/users",
        creatingTitle: "Novo Usuário",
        updatingTitle: "Alterar Usuário",
        service: new UserService(),
        user: { active: true, group: "employee" },        
        password: "",
        confPassword: "",
        signature: {
          file: null,
          column: 0,
          width: 0,
          height: 0,
          marginTop: 0,
          marginBottom: 0,          
        },
        serviceTypeIcons: SrvService.TYPE_ICONS,
      }
    },    

    components: {
      UserGroupIcon,
      FileUpload,
      SelectDay,
      SelectMonth,
      SelectBank,
      SelectState,
      TheMask,
    },

    created() {
      
      this.initFormPage()

      if (this.isUpdating)
        this.loadUser()      
    },    

    mounted() {

      $(".user-form-checkbox").checkbox()

      Input.maskInteger()
      Input.maskFloat()
    },

    computed: {

      isRootUser() {
        return (this.isUpdating && this.user.id == 1)
      },

      isLoggedUser() {
        return (this.$route.params.id == this.$store.state.auth.user.id)
      },

      disableAccessSegment() {
        return (this.isLoggedUser || this.isRootUser)
      },

      person() {
        return this.user.cgc && this.user.cgc.trim().length > 11 ? "J" : "F"
      },

      signatureColumn: {
        get() {
          return Input.integerToString(this.signature.column)
        },
        set(value) {
          this.signature.column = Input.stringToInteger(value)          
        },
      },

      signatureWidth: {
        get() {
          return Input.integerToString(this.signature.width)
        },
        set(value) {
          this.signature.width = Input.stringToInteger(value)          
        },
      },

      signatureHeight: {
        get() {
          return Input.integerToString(this.signature.height)
        },
        set(value) {
          this.signature.height = Input.stringToInteger(value)          
        },
      },

      signatureMarginTop: {
        get() {
          return Input.integerToString(this.signature.marginTop)
        },
        set(value) {
          this.signature.marginTop = Input.stringToInteger(value)          
        },
      },

      signatureMarginBottom: {
        get() {
          return Input.integerToString(this.signature.marginBottom)
        },
        set(value) {
          this.signature.marginBottom = Input.stringToInteger(value)          
        },
      },    

      normalAdd: {
        get() {
          return Input.floatToString(this.user.normalAdd)
        },
        set(value) {
          this.user.normalAdd = Input.stringToFloat(value)    
        },
      },

      returnAdd: {
        get() {
          return Input.floatToString(this.user.returnAdd)
        },
        set(value) {
          this.user.returnAdd = Input.stringToFloat(value)    
        },
      },

      dutyAdd: {
        get() {
          return Input.floatToString(this.user.dutyAdd)
        },
        set(value) {
          this.user.dutyAdd = Input.stringToFloat(value)    
        },
      },

      othersAdd: {
        get() {
          return Input.floatToString(this.user.othersAdd)
        },
        set(value) {
          this.user.othersAdd = Input.stringToFloat(value)    
        },
      },

      canConfirm() {

        const { name, lastName, email } = this.user

        if (!name || !lastName || !email || this.removing)
          return false

        if (this.isCreating && (!this.password || !this.confPassword))
          return false  

        return true
      },
    },

    methods: {

      async loadUser() {

        this.loading = true

        try {

          this.user = await this.service.findById(this.$route.params.id)

          if (this.user.signature) {
            this.signature.column = this.user.signature.column            
            this.signature.width = this.user.signature.width
            this.signature.height = this.user.signature.height
            this.signature.marginTop = this.user.signature.marginTop
            this.signature.marginBottom = this.user.signature.marginBottom
            this.signature.name = this.user.signature.name
            this.signature.crmv = this.user.signature.crmv
          }

          this.$refs.selectBirthDay.setSelected(this.user.birthDay)
          this.$refs.selectBirthMonth.setSelected(this.user.birthMonth)
          this.$refs.selectState.setSelected(this.user.state)
          this.$refs.selectBank.setSelected(this.user.bankCode)

          this.$refs.signatureUploader.loadFiles()

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onChangeBirthDay(birthDay) {        
        this.user.birthDay = birthDay
      },

      onChangeBirthMonth(birthMonth) {        
        this.user.birthMonth = birthMonth
      },

      async loadAddressByZipCode() {

        if (!this.user.zipCode || this.user.zipCode.trim().length < 8)
          return
        
        try {

          const data = await ZipCodeService.fetch(this.user.zipCode)

          if (!data || data.erro)
            return

          this.user.address = data.logradouro          
          this.user.district = data.bairro
          this.user.city = data.localidade

          this.$refs.selectState.setSelected(data.uf)          
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      onChangeState(state) {        
        this.user.state = state
        this.user = this.$cloneObject(this.user)
      },

      onChangeBank(bankCode) {        
        this.user.bankCode = bankCode
        this.user = this.$cloneObject(this.user)
      },

      async onConfirm() {

        if (!this.validData())
          return

        this.saving = true

        try {

          if (this.signature.file) {
            this.user.signature = {
              column: this.signature.column,
              width: this.signature.width,
              height: this.signature.height,
              marginTop: this.signature.marginTop,
              marginBottom: this.signature.marginBottom,
              name: this.signature.name,
              crmv: this.signature.crmv,
            }
          } else {
            this.user.signature = null
          }

          if (this.isCreating) {
            await this.service.create({ user: this.user, password: this.password })
          } else {
            await this.service.update(this.user)
          }

          this.$reloadDataTables()

          this.$msg.success(this.isCreating ? "Usuário criado com sucesso" : "Usuário atualizado com sucesso")

          this.goBack()

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        if (this.isCreating && this.password.trim().length < 6) {
          message = "A senha deve possuir ao menos 6 caracteres"
        } else if (this.isCreating && this.password != this.confPassword) {
          message = "Senha não confirmada corretamente"
        } else if (this.signature.file && !this.signature.column) {
          message = "Informe a coluna da assinatura" 
        } else if (this.signature.file && !this.signature.width) {
          message = "Informe a largura da assinatura"    
        } else if (this.signature.file && !this.signature.height) {
          message = "Informe a altura da assinatura"      
        } else if (this.signature.file && !this.signature.name) {
          message = "Informe o nome para assinatura"
        } else if (this.signature.file && !this.signature.crmv) {
          message = "Informe o CRMV  para assinatura"  
        }

        if (message) {
          isOk = false
          this.$msg.info(message)           
        }

        return isOk
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.user)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {

          await this.service.remove(this.user)

          if (this.signature.file)
            await this.$refs.signatureUploader.removeFile()

          this.$reloadDataTables()

          this.$msg.success("Usuário excluído com sucesso")

          this.goBack()

        } catch (error) {

          this.$errorHandler(error)
        
        } finally {

          this.removing = false
        }
      },

      async loadSignature() {

        if (!this.user.id)
          return

        try {

          this.signature.file = await this.service.getUserSignature(this.user.id)       

          if (!this.signature.file)
            this.signature.file = null

          if (this.signature.file && !this.user.signature)
            this.setDefaultSignatureCoordinates()     
          
        } catch (error) {
          
          this.$errorHandler(error)
        }

        return this.signature.file
      }, 

      setDefaultSignatureCoordinates() {
        this.signature.column = 235
        this.signature.width = 140
        this.signature.height = 50
        this.signature.marginTop = 1
        this.signature.marginBottom = 1
      },

      async onRemoveSignature(image) {

        try {

          await this.service.removeUserSignature(this.user.id, image) 

          this.signature.file = null
          this.user.signature = null

          this.setDefaultSignatureCoordinates()

          await this.service.update(this.user)

          this.$reloadDataTables()
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },
    },
  }

</script>

